import { render, staticRenderFns } from "./all-order-product.vue?vue&type=template&id=37500bb6"
import script from "./all-order-product.vue?vue&type=script&lang=js"
export * from "./all-order-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports